import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { CommonModule } from '@angular/common';

// Angular material components
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

// Custom services 
import { LanguageService } from '../../../services/language/language.service';
import { UtilsService } from '../../../services/utils/utils.service';

import {UntypedFormControl, FormGroupDirective, NgForm, Validators, AbstractControl, FormBuilder} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';

/* Error when invalid control is dirty, touched, or submitted (input fields) */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    //const isSubmitted = form && form.submitted;
    //return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    return !!(control && control.invalid && (control.dirty || control.touched ));
  }
}


/* Specify the structure of the dictionary that will receive the dialog when being openned */
export interface DialogData {proposedFileName:string}


@Component({
  selector: 'app-file-name-popup',
  standalone: true,
  imports: [
    // Angular modules
    CommonModule, 
    // Material design modules
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    // Custom modules
  ],
  templateUrl: './file-name-popup.component.html',
  styleUrl: './file-name-popup.component.css'
})
export class FileNamePopupComponent {


  proposedFileName:string = null
  
  // Individual form controls and error matcher
  maxLength = 50
  stringFormControl_proposedFileName = new UntypedFormControl('', [
    Validators.required, 
    this.specialCharactersValidators.bind(this),
    this.spacesInStringValidators.bind(this),
    Validators.maxLength(this.maxLength),
  ]); 
  matcher = new MyErrorStateMatcher();

  // Form control group (need to keep this name cause its binded to parents form control)
  //    It needs to be created before constructing and initializing the view  
  formControlGroup = this._formBuilder.group({
    proposedFileName: this.stringFormControl_proposedFileName,
  }, 
  {});



  constructor(private _formBuilder:FormBuilder,
    public languageService:LanguageService,
    public utilsService:UtilsService,
    public dialogRef: MatDialogRef<FileNamePopupComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: DialogData)
  {
    this.proposedFileName = this.utilsService.deepCopyDict(data.proposedFileName)
  }


  ngOnInit(): void {
    this.stringFormControl_proposedFileName.setValue(this.proposedFileName)
  }



  // ----- Action buttons ----- //
  cancelButtonClicked(){
    this.dialogRef.close({shouldDownloadFile:false})
  }
  acceptButtonClicked(){
    this.dialogRef.close({shouldDownloadFile:true, 
                          proposedFileName:this.stringFormControl_proposedFileName.value.toString()})
  }
  keyboardPress($event){
    /*
    // Enter pressed (13)
    if($event.keyCode == 13) {
      $event.preventDefault();
      if(this.formControlGroup.valid){
        this.loginButtonclicked()
      }
      return false;
    }
    // Scape pressed (27) - Only trigered in keyboardUp
    if($event.keyCode == 27) {
      $event.preventDefault();
      return false
    }
    return true
    */
  }

  keyboardUp($event){
    /*
    // Enter pressed (13) - Only trigered in keyboardPress
    if($event.keyCode == 13) {
      $event.preventDefault();
      return false;
    }
    // Scape pressed (27)
    if($event.keyCode == 27) {
      $event.preventDefault();
      this.cancelButtonClicked()
    }
    return true
    */
  }


  // ----- Validators ----- //

  specialCharactersValidators(control: AbstractControl) {
    //let addmittedCharacters = /^[a-zA-Z0-9_]*$/; // regular expression (solo símbolos a-z, A-Z, 0-9, _)
    let addmittedCharacters = /^[a-zA-Z0-9\t\n ./<>¿?;:"'`¡!@#$%^&*()\[\]{}_+=ºªñÑ,·çüÜ|\\-áéíóúÁÉÍÓÚ]*$/; // regular expression
    let currentString = control.value
    if(currentString){
      if(currentString.length > 0){
        if(!addmittedCharacters.test(currentString)){
          return { specialCharactersValidationError: true };
        }
      }
    }
    return null;
  }


  spacesInStringValidators(control: AbstractControl) {
    let currentString = control.value
    if(currentString){
      if(currentString.length > 0){
        if(currentString.indexOf(' ') >= 0){
          return { spacesInStringValidationError: true };
        }
      }
    }
    return null;
  }
  

}
